import { ContentType } from '../../PerformancePortal/Notifications/NotificationsPopover';
import { convertEnumToObject } from '../../Util';
import { AWSDateTime } from '../CoachingForm/schema';

export type AWSJSON = string;
export type AuditEvents = {
  timestamp: string;
  type: AuditType;
  data: string;
};

export type Schedule = {
  type: ScheduleType;
  scheduledAt: string;
};

export enum AuditType {
  ERROR,
  INFO,
}

export enum Channel {
  APP,
  EMAIL,
}

export const ChannelObject = convertEnumToObject(Channel);

export enum Status {
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  READ = 'READ',
  SCHEDULED = 'SCHEDULED',
  SENT = 'SENT',
  DISMISSED = 'DISMISSED',
}

export enum StatusInput {
  CANCELLED,
  READ,
  DISMISSED,
}

export const StatusObject = convertEnumToObject(Status);
export const StatusInputObject = convertEnumToObject(StatusInput);

export enum ScheduleType {
  ONCE,
  IMMEDIATELY,
}

export interface Notification {
  workflowId?: string;
  notificationId: string;
  channel: Channel;
  status?: Status;
  lastUpdated?: AWSDateTime;
  sentTime?: AWSDateTime;
  schedule?: Schedule;
  target: string;
  metadata?: AWSJSON;
}

export interface AppNotification extends Notification {
  message: AppMessage;
}

export type AppMessage = {
  charset: string;
  body: AppBody;
};

export type AppBody = {
  content: AWSJSON;
  metadata?: AWSJSON;
};

export interface NotificationMetadata {
  notificationType?: string;
  notificationCategory?: string;
}

export interface Content {
  contentType: ContentType;
  title: string;
  message: string;
  nav?: Nav;
  dismissable?: boolean;
  feedback?: Feedback;
}

export interface Nav {
  text: string;
  link: string;
  relativeLink: string;
}

export interface Feedback {
  options: { option: string };
}
